import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumnFilterType } from "./TransactionColumnFilterType";

export function TransactionColumnHeaderType(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.TYPE}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.TYPE}
        text={"Type"}
        FilterType={TransactionColumnFilterType}
      />
    </TransactionColumnSizer>
  );
}
